import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  InputAdornment,
  Typography,
} from '@mui/material';
import AurSearchBox from '../common/aur-search-box/AurSearchBox';
import {
  LOAD_DOC_TYPE,
  MIN_SEARCH_CHAR,
  SCOPE_TYPE,
  MAX_CHAR,
  ERROR_STATUS_CODE,
  TOAST_TIMEOUT,
  SSE_ENDPOINT_ECA,
  SSE_SERVICE_TYPE,
} from '../../constants/constants';
import AurLocationTreeView from '../eca-doc-list/eca-save-search/AurLocationTreeView';
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { RootState } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteSavedSearch,
  deleteSavedSearchGroup,
  getGroupDetails,
  getSavedSearchDetails,
  getSavedSearchGroupsRoot,
  savedSearchedRun,
  updateSaveSearchDetails,
} from '../../api/EcaServices';
import { t } from 'i18next';
import { TreeViewBaseItem } from '@mui/x-tree-view';
import { ExtendedTreeItemProps } from '../eca-doc-list/eca-save-search/EcaSaveSearch';
import AurLoadingIndicator from '../common/aur-loading-indicator/AurLoadingIndictor';
import ECAFlyout from './ECAFlyout';
import AurButton from '../common/aur-button/AurButton';
import AurIcon, { IconColors, IconNames } from '../common/aur-icon/AurIcon';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import AurIconButton from '../common/aur-button/AurIconButton';
import {
  createQueryUsingScopeObj,
  extractSavedSearchId,
  findTreeNodeById,
  formatNumberWithComma,
  getExpandableIds,
  getLabelFromScopeQuery,
  getSavedSearchResFromEntity,
  getTreeObjectFromSavedSearch,
  checkSavedSearchLastRun,
  getUTCDateTimeForDisplay,
  isValidName,
  unwrapQueryText,
  wrapQueryBeforeSymbol,
} from '../../utils/utils';
import { AxiosError } from 'axios';
import { useToast } from '../../contexts/toastContext/ToastContext';
import {
  IGlobalSelectedItem,
  setGlobalSavedSearchDetails,
  setIsDeduplicationModal,
  setSavedSearchLastRun,
  setSavedSearchDeleteConfirm,
} from '../../redux/slices/ecaAdhocSearchSlice';
import { AurTextField } from '../common/aur-text-field/AurTextField';
import { ReactComponent as InfoIcon } from '../../assests/svg/info-outlined-red.svg';
import { isEmpty, noop } from 'lodash';
import { setNewSearch } from '../../redux/slices/ecaDocListSlice';
import AurPopup from '../common/aur-popup/AurPopup';
import { RelationalGroup } from '../pages/index-search/RelationshipGroupPopup';
import MoveSavedSearchGroupPopup from './MoveSavedSearchGroupPopup';
import AurBanner from '../common/aur-banner/AurBanner';
import AurTooltip from '../common/aur-tooltip/AurTooltip';
import RGFWarningPopupAlert from '../pages/index-search/RGFWarningPopupAlert';
import {
  getDisabledRelationshipFieldText,
  isDisabledRGFExistInSavedSearch,
} from '../pages/index-search/query-field/query-field-utils';
import { AurLoadingButton } from '../common/aur-loading-button/AurLoadingButton';
import { AurLightTooltip } from '../common/aur-light-tooltip/aur-light-tooltip';
import {
  PAGE_NAME,
  usePermissionsByPage,
} from '../../hooks/permissions/usePermissionsByPage';

export enum Flow_Type {
  STR = 'STR',
  OTHER = 'Other',
}
interface IFilterItem {
  column: string;
  operator: string;
  value: string;
  linkOperator?: string;
  items?: IFilterItem[];
}
interface IFilterSet {
  linkOperator: string;
  items: IFilterItem[];
}

export interface SavedSearchRes {
  groupId?: string;
  name: string;
  type: string;
  parentGroupId?: string;
  numberOfChild?: number;
  indexName: string;
  savedSearchId?: string;
  isPublic?: boolean;
  notes?: string;
  isDefault?: boolean;
  createdBy?: string;
  createdTime?: string;
  ecaSearchId?: string;
  savedSearchList?: SavedSearchRes[];
  children?: SavedSearchRes[];
}

export interface SavedSearchEntity {
  entity: SavedSearchRes;
  childNodes: SavedSearchEntity[];
}
export interface SavedSearchDetails {
  name: string;
  id: string;
  useAsScope: boolean;
  createdDetail: {
    createdUserId: string;
    createdUserName: string;
    createdTime: string;
  };
  updatedDetail: {
    updatedUserId: string;
    updatedUserName: string;
    updatedTime: string;
  };
  lastRunDetail: {
    lastRunUserId: string;
    lastRunUserName: string;
    lastRunTime: string;
  };
  type: string;
  queryBuilderFlag: boolean;
  query: string;
  noScopeDtSyntaxQuery?: string;
  dtSyntaxQuery?: string;
  filterSet: IFilterSet;
  docCount: number;
  filteredDocCount?: number;
  notes: string;
  fieldTemplateId: number;
  indexName: string;
  ecaSearchId: string;
  isPublicFlag: boolean;
  applyFilter: boolean;
  scope: {
    scopeType: string;
    scopeId: string;
    scopeName: string;
  };
  columnOrder: string[];
  relationalGroups?: number[];
  relationalGroupFieldList?: number[];
  sortOrder: {
    column: string;
    direction: string;
  }[];
  groupId: string;
  isDefault: boolean;
  relationalGroupList?: RelationalGroup[];
  jsonLogicQuery?: string;
}
const initialSavedSearchDetails = {
  name: '',
  id: '',
  useAsScope: false,
  createdDetail: {
    createdUserId: '',
    createdUserName: '',
    createdTime: '',
  },
  updatedDetail: {
    updatedUserId: '',
    updatedUserName: '',
    updatedTime: '',
  },
  lastRunDetail: {
    lastRunUserId: '',
    lastRunUserName: '',
    lastRunTime: '',
  },
  type: '0',
  queryBuilderFlag: false,
  query: '',
  noScopeDtSyntaxQuery: '',
  dtSyntaxQuery: '',
  docCount: 0,
  filterSet: {
    linkOperator: '',
    items: [
      {
        column: '',
        operator: '',
        value: '',
      },
    ],
  },
  notes: '',
  fieldTemplateId: 0,
  indexName: '',
  ecaSearchId: '',
  isPublicFlag: false,
  applyFilter: false,
  scope: {
    scopeType: '',
    scopeId: '',
    scopeName: '',
  },
  columnOrder: [''],
  relationalGroups: [],
  sortOrder: [
    {
      column: '',
      direction: '',
    },
  ],
  groupId: '',
  isDefault: false,
};

interface ISavedGroupDetails {
  createdBy: string;
  createdTime: string;
  updatedBy: string;
  updatedTime: string;
}

const initialSavedGoupDetails = {
  createdBy: '',
  createdTime: '',
  updatedBy: '',
  updatedTime: '',
};

interface Props {
  selectedIndex: string;
  enableFlayout?: boolean;
  renderSelectedSearchDetail?: (element: ReactElement) => void;
  openForPickSavedSearch?: boolean; // Set it true when open this for select saved search
  enableSearch?: boolean;
  searchInput?: string;
  showNotes?: boolean;
  indexNameLabel?: string;
  onPickTreeItem?: (
    treeItem: TreeViewBaseItem<ExtendedTreeItemProps> | null
  ) => void;
  onPickSavedSearch?: (
    data: {
      id: string;
      label: string;
      ecaSearchId: string;
      directory_structure_ids?: string;
    } | null
  ) => void;
  onFetchSavedSearch?: (savedSearchDetails: SavedSearchDetails) => void;
  selectedSearch?: TreeViewBaseItem<ExtendedTreeItemProps> | null;
  expandedIds?: string[];
  handleUseAsScope?: (flag: string, selectedItem: IGlobalSelectedItem) => void;
  handleViewDocs?: (flag: string, selectedItem: IGlobalSelectedItem) => void;
  handleAddToTemplate?: (selectedItem: IGlobalSelectedItem) => void;
  folderDetailsView?: boolean;
  showActions?: boolean;
  manageSaved?: boolean;
  manageSearchRename?: boolean;
  deleteOption?: boolean;
  isDeleteSuccessful?: boolean;
  ecaAdminPermission?: boolean;
  handleSearchId?: boolean;
  drawerRef?: React.RefObject<HTMLDivElement>;
  userId?: string;
  flowType?: Flow_Type;
  onLoadedDetails?: (isLoading: boolean) => void;
  cacheKey?: string;
  cachedRootData?: TreeViewBaseItem<ExtendedTreeItemProps>[];
  onRootDataChange?: (
    data?: TreeViewBaseItem<ExtendedTreeItemProps>[]
  ) => void;
}

interface PopupConfig {
  title: string;
  heading: string;
  content: string;
  buttonCancel: string;
  buttonYes: string;
  showCancel: boolean;
}

const SavedSearchPanel: React.FC<Props> = ({
  selectedIndex,
  enableFlayout = true,
  renderSelectedSearchDetail,
  onPickTreeItem,
  onPickSavedSearch,
  openForPickSavedSearch = false,
  enableSearch = true,
  searchInput,
  showNotes = true,
  indexNameLabel = t('eca.flyout.savedSearch.indexName'),
  selectedSearch = null,
  expandedIds = [''],
  handleUseAsScope,
  handleViewDocs,
  handleAddToTemplate,
  folderDetailsView = false,
  showActions = false,
  manageSaved = false,
  manageSearchRename = false,
  deleteOption = false,
  isDeleteSuccessful = false,
  ecaAdminPermission = true,
  handleSearchId = false,
  onFetchSavedSearch,
  drawerRef,
  userId,
  flowType = Flow_Type.OTHER,
  onLoadedDetails,
  cacheKey,
  cachedRootData,
  onRootDataChange,
}) => {
  const [treeData, setTreeData] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps>[]>();
  const [currentExpandedIds, setCurrentExpandedIds] = useState(expandedIds);
  const [saveSearchedData, setSaveSearchedData] = useState<
    TreeViewBaseItem<ExtendedTreeItemProps>[]
  >([]);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [showFlyout, setShowFlyout] = useState(false);
  const [savedSearchedDetails, setSavedSearchedDetails] =
    useState<SavedSearchDetails>(initialSavedSearchDetails);
  const [loadingLastDocCount, setLoadingLastDocCount] = useState<boolean>();
  const [loadingFlyout, setLoadingFlyout] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedNode, setSelectedNode] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps> | null>(selectedSearch);
  const [selectedNodeToMove, setSelectedNodeToMove] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps> | null>(null);
  const [isNameEditing, setIsNameEditing] = useState<boolean>(false);
  const [renameSearch, setRenameSearch] = useState('');
  const [renameSearchError, setRenameSearchError] = useState<boolean>(false);
  const [savedGroupDetails, setSavedGroupDetails] =
    useState<ISavedGroupDetails>(initialSavedGoupDetails);
  const [isEditNotes, setIsEditNotes] = useState<boolean>(false);
  const [updatedNotes, setUpdatedNotes] = useState<string>('');
  const [isLoadingEditNotes, setIsLoadingEditNotes] = useState<boolean>(false);
  const [selectedGroupId, setSelectedGroupId] = useState<string>('');
  const [selectedGroupName, setSelectedGroupName] = useState<string>('');
  const [selectedAction, setSelectedAction] = useState('');
  const [isMoveModalOpen, setIsMoveModalOpen] = useState(false);
  const [expandedNodes, setExpandedNodes] = useState<string[]>([]);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const isMoveCompleted = useRef<boolean>(false);
  const { showToast } = useToast();
  const abortControllers = useRef<Map<string, AbortController>>(new Map());
  const cacheKeyRef = useRef(cacheKey);
  const cachedRootDataRef = useRef(cachedRootData);
  const onRootDataChangeRef = useRef(onRootDataChange);
  const componentMountedRef = useRef(true);

  cacheKeyRef.current = cacheKey;
  cachedRootDataRef.current = cachedRootData;
  onRootDataChangeRef.current = onRootDataChange;

  const isCacheEnabled = Boolean(cacheKey && onRootDataChange);

  const { clientId, projectId } = useSelector(
    (state: RootState) => state.reports
  );

  const { addGroupCheck: addGroupCheckStatus, manageSavedSearch, relationalGroupsList, showSetScopeLoader, ecaDrawerFlag } = useSelector(
    (state: RootState) => state.ecaAdhocSearch
  );

  const { builder } = useSelector((state: RootState) => state.query);
  const { queryData } = useSelector((state: RootState) => state.ecaDocList);

  const { hasSavedSearchTemplatesPerm } = usePermissionsByPage(
    PAGE_NAME.SEARCH_SAVE_PANEL
  );

  const dispatch = useDispatch();
  const [popupState, setPopupState] = useState({
    open: false,
    type: '',
    id: '',
    label: '',
    path: '',
  });
  const [showRGFWarningPopup, setShowRGFWarningPopup] =
    useState<boolean>(false);

  const flyoutButtonMinWidth = 150;

  const popupConfig: Record<string, PopupConfig> = {
    cantDeleteGroup: {
      title: t(
        'eca.savedSearchManagement.cantDeleteGroupWarningModal.popupTitle'
      ),
      heading: t(
        'eca.savedSearchManagement.cantDeleteGroupWarningModal.popupHeading'
      ),
      content: t(
        'eca.savedSearchManagement.cantDeleteGroupWarningModal.popupContent'
      ),
      buttonCancel: t(
        'eca.savedSearchManagement.cantDeleteGroupWarningModal.buttonCancel'
      ),
      buttonYes: t(
        'eca.savedSearchManagement.cantDeleteGroupWarningModal.buttonYes'
      ),
      showCancel: false,
    },
    deleteGroup: {
      title: t('eca.savedSearchManagement.deleteGroupWarningModal.popupTitle'),
      heading: t(
        'eca.savedSearchManagement.deleteGroupWarningModal.popupHeading'
      ),
      content: t(
        'eca.savedSearchManagement.deleteGroupWarningModal.popupContent'
      ),
      buttonCancel: t(
        'eca.savedSearchManagement.deleteGroupWarningModal.buttonCancel'
      ),
      buttonYes: t(
        'eca.savedSearchManagement.deleteGroupWarningModal.buttonYes'
      ),
      showCancel: true,
    },
    cantDeleteSavedSearch: {
      title: t(
        'eca.savedSearchManagement.cantDeleteSavedSearchWarningModal.popupTitle'
      ),
      heading: t(
        'eca.savedSearchManagement.cantDeleteSavedSearchWarningModal.popupHeading'
      ),
      content: t(
        'eca.savedSearchManagement.cantDeleteSavedSearchWarningModal.popupContent'
      ),
      buttonCancel: t(
        'eca.savedSearchManagement.cantDeleteSavedSearchWarningModal.buttonCancel'
      ),
      buttonYes: t(
        'eca.savedSearchManagement.cantDeleteSavedSearchWarningModal.buttonYes'
      ),
      showCancel: false,
    },
    deleteSavedSearch: {
      title: t(
        'eca.savedSearchManagement.deleteSavedSearchWarningModal.popupTitle'
      ),
      heading: t(
        'eca.savedSearchManagement.deleteSavedSearchWarningModal.popupHeading'
      ),
      content: t(
        'eca.savedSearchManagement.deleteSavedSearchWarningModal.popupContent'
      ),
      buttonCancel: t(
        'eca.savedSearchManagement.deleteSavedSearchWarningModal.buttonCancel'
      ),
      buttonYes: t(
        'eca.savedSearchManagement.deleteSavedSearchWarningModal.buttonYes'
      ),
      showCancel: true,
    },
  };

  useEffect(() => {
    onLoadedDetails?.(
      !isEmpty(extractSavedSearchId(savedSearchedDetails?.id)) &&
      extractSavedSearchId(selectedNode?.id) ===
      extractSavedSearchId(savedSearchedDetails?.id)
    );
  }, [onLoadedDetails, savedSearchedDetails?.id, selectedNode?.id]);

  const prevSearch = useRef<boolean>(false);
  useEffect(() => {
    if (prevSearch.current) {
      setLoading(true);
      setSelectedNode(null);
      onPickSavedSearch?.(null);
      if (manageSaved) {
        renderSelectedSearchDetail?.(InitialContent());
      }
      fetchSaveSearchGroupsRoot(
        searchKeyword
          ? { searchTerm: searchKeyword, indexName: selectedIndex }
          : {},
        false
      );
    }
    prevSearch.current = true;
  }, [searchKeyword, selectedIndex]);

  useEffect(() => {
    if (selectedSearch?.id) {
      fetchSavedSearchDetails(selectedSearch.id)
        .then(() => {
          onPickSavedSearch?.({
            id: selectedSearch.id,
            label: savedSearchedDetails.name,
            ecaSearchId: savedSearchedDetails.ecaSearchId,
            directory_structure_ids: currentExpandedIds.join('/'),
          });
        })
        .catch(noop);
    }
  }, []);

  useEffect(() => {
    if (savedSearchedDetails !== initialSavedSearchDetails && handleSearchId) {
      const getSavedSearchId = () => {
        switch (flowType) {
          case Flow_Type.STR:
            return savedSearchedDetails.id;
          case Flow_Type.OTHER:
            return savedSearchedDetails.ecaSearchId;
          default:
            return savedSearchedDetails.ecaSearchId;
        }
      };
      onPickSavedSearch?.({
        id: getSavedSearchId(),
        label: savedSearchedDetails.name,
        ecaSearchId: savedSearchedDetails.ecaSearchId,
        directory_structure_ids: currentExpandedIds.join('/'),
      });
    }
    onFetchSavedSearch?.(savedSearchedDetails);
  }, [savedSearchedDetails]);

  useEffect(() => {
    if (!enableSearch) {
      setSearchKeyword(searchInput ?? '');
    }
    if (manageSaved && searchInput === '') {
      setSelectedNode(null);
      renderSelectedSearchDetail?.(InitialContent());
    }
  }, [searchInput, enableSearch]);

  useEffect(() => {
    if (
      !enableFlayout &&
      renderSelectedSearchDetail &&
      selectedNode &&
      selectedNode.fileType !== 'folder'
    ) {
      renderSelectedSearchDetail(renderLoadFlyoutContent());
    }
  }, [
    savedSearchedDetails,
    selectedNode,
    enableFlayout,
    renderSelectedSearchDetail,
    loadingLastDocCount,
    loading,
  ]);

  useEffect(() => {
    if (selectedSearch) {
      setSelectedNode(selectedSearch);
    }
  }, [selectedSearch]);

  useEffect(() => {
    if (savedGroupDetails !== initialSavedGoupDetails && manageSaved) {
      renderSelectedSearchDetail?.(
        renderFolderContent(
          selectedGroupId,
          selectedGroupName,
          savedGroupDetails
        )
      );
    }
  }, [savedGroupDetails]);

  const paramsClientProject = `?clientId=${clientId}&projectId=${projectId}`;

  /**
   * Fetch saved search Root API
   */
  const applySavedSearchRoot = (
    mappedArray: TreeViewBaseItem<ExtendedTreeItemProps>[],
    ignoreExpandedIds = false
  ) => {
    if (!isEmpty(mappedArray)) {
      if (!isEmpty(searchKeyword)) {
        setSelectedNode(selectedSearch);
        setCurrentExpandedIds(getExpandableIds(mappedArray));
      } else if (!ignoreExpandedIds) {
        setSelectedNode(selectedSearch);
        setCurrentExpandedIds(expandedIds ?? ['']);
      }

      if (selectedNodeToMove && isMoveCompleted.current) {
        const updatedNode = findTreeNodeById(
          mappedArray,
          selectedNodeToMove.id
        );
        if (updatedNode) {
          isMoveCompleted.current = false;
          setSelectedNode({...updatedNode});
          setCurrentExpandedIds(
            updatedNode?.directory_structure_ids?.split('/') ?? []
          );
        }
      }
    }

    setSaveSearchedData(mappedArray);
    setLoading(false);
  };

  const fetchSaveSearchGroupsRoot = async (
    params: Record<string, unknown> = {},
    ignoreExpandedIds = false,
    forceRefresh = false
  ) => {
    const requestKey = cacheKey;
    const isFilteredRequest = Boolean(
      params.searchTerm || params.indexName
    );
    const requestIsCurrent = () =>
      !isCacheEnabled || requestKey === cacheKeyRef.current;

    if (
      isCacheEnabled &&
      !forceRefresh &&
      !isFilteredRequest &&
      cachedRootDataRef.current !== undefined
    ) {
      applySavedSearchRoot(cachedRootDataRef.current, ignoreExpandedIds);
      return;
    }

    if (!clientId || !projectId) {
      if (requestIsCurrent()) {
        setLoading(false);
      }
      return;
    }

    setLoading(true);
    try {
      const result = await getSavedSearchGroupsRoot({
        clientId,
        projectId,
        ...params,
      });

      if (!requestIsCurrent() || !componentMountedRef.current) {
        return;
      }

      const {data: savedSearchData} = result.data;
      let mappedArray: TreeViewBaseItem<ExtendedTreeItemProps>[] = [];

      if (!isEmpty(savedSearchData)) {
        const resData: SavedSearchRes = getSavedSearchResFromEntity(
          savedSearchData?.[0] ?? {}
        );

        mappedArray = [resData].map(
          (item: SavedSearchRes, index: number) =>
            getTreeObjectFromSavedSearch(item, index, item?.groupId ?? '')
        );
      }

      applySavedSearchRoot(mappedArray, ignoreExpandedIds);

      if (isCacheEnabled) {
        if (!isFilteredRequest) {
          onRootDataChangeRef.current?.(mappedArray);
        } else if (forceRefresh) {
          onRootDataChangeRef.current?.(undefined);
        }
      }
    } catch (error: unknown) {
      if (!requestIsCurrent() || !componentMountedRef.current) {
        return;
      }

      const err = error as AxiosError;
      showToast(err.message, 'error', undefined, 'center');
      setLoading(false);
    }
  };

  const fetchUpdatedSaveSearchGroupsRoot = useCallback(async () => {
    const requestKey = cacheKey;
    const isFilteredRequest = Boolean(searchKeyword);
    const requestIsCurrent = () =>
      !isCacheEnabled || requestKey === cacheKeyRef.current;

    if (clientId && projectId) {
      try {
        const result = await getSavedSearchGroupsRoot({
          clientId,
          projectId,
          ...(searchKeyword
            ? {searchTerm: searchKeyword, indexName: selectedIndex}
            : {}),
        });

        if (!requestIsCurrent() || !componentMountedRef.current) {
          return [];
        }

        const {data: savedSearchData} = result.data;
        let mappedArray: TreeViewBaseItem<ExtendedTreeItemProps>[] = [];
        if (!isEmpty(savedSearchData)) {
          const resData: SavedSearchRes = getSavedSearchResFromEntity(
            savedSearchData?.[0] ?? {}
          );

          mappedArray = [resData].map((item: SavedSearchRes, index: number) =>
            getTreeObjectFromSavedSearch(item, index, item?.groupId ?? '')
          );
        }

        if (isCacheEnabled) {
          onRootDataChangeRef.current?.(
            isFilteredRequest ? undefined : mappedArray
          );
        }

        return mappedArray;
      } catch (error: unknown) {
        if (!requestIsCurrent() || !componentMountedRef.current) {
          return [];
        }

        const err = error as AxiosError;
        showToast(err.message, 'error', undefined, 'center');
      }
    }
    return [];
  }, [
    cacheKey,
    clientId,
    isCacheEnabled,
    projectId,
    searchKeyword,
    selectedIndex,
    showToast,
  ]);

  const previousRootCacheKey = useRef(cacheKey);
  const previousCachedRootData = useRef(cachedRootData);
  const rootInitialized = useRef(false);

  useEffect(() => {
    const keyChanged = previousRootCacheKey.current !== cacheKey;
    const cacheDataChanged =
      previousCachedRootData.current !== cachedRootData;
    const isInitialLoad = !rootInitialized.current;
    const cacheWasInvalidated =
      isCacheEnabled &&
      cacheDataChanged &&
      cachedRootData === undefined;

    previousRootCacheKey.current = cacheKey;
    previousCachedRootData.current = cachedRootData;

    if (
      !isInitialLoad &&
      !keyChanged &&
      cacheWasInvalidated &&
      !isEmpty(searchKeyword)
    ) {
      return;
    }

    if (
      !isInitialLoad &&
      !keyChanged &&
      !cacheDataChanged
    ) {
      return;
    }

    if (manageSaved) {
      renderSelectedSearchDetail?.(InitialContent());
    }

    rootInitialized.current = true;

    if (
      isCacheEnabled &&
      cachedRootData !== undefined &&
      !(isInitialLoad && ecaDrawerFlag)
    ) {
      applySavedSearchRoot(cachedRootData);
      return;
    }

    setLoading(true);
    fetchSaveSearchGroupsRoot(
      {},
      false,
      (isInitialLoad && Boolean(ecaDrawerFlag)) ||
        cacheWasInvalidated
    );
  }, [cacheKey, cachedRootData, ecaDrawerFlag, isCacheEnabled]);

  const previousEcaDrawerFlag = useRef(ecaDrawerFlag);
  const ecaDrawerFlagEffectInitialized = useRef(false);
  useEffect(() => {
    const isRaised = ecaDrawerFlag && !previousEcaDrawerFlag.current;
    const isInitialEffect = !ecaDrawerFlagEffectInitialized.current;
    ecaDrawerFlagEffectInitialized.current = true;
    previousEcaDrawerFlag.current = ecaDrawerFlag;

    if (
      ecaDrawerFlag &&
      (isRaised || (!isCacheEnabled && isInitialEffect))
    ) {
      setLoading(true);
      fetchSaveSearchGroupsRoot(
        searchKeyword
          ? {searchTerm: searchKeyword, indexName: selectedIndex}
          : {},
        false,
        true
      );
    }
  }, [ecaDrawerFlag, isCacheEnabled, searchKeyword, selectedIndex]);

  useEffect(() => {
    return () => {
      componentMountedRef.current = false;
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
    };
  }, []);

  const fetchGroupDetails = async (id: string) => {
    if (clientId && projectId && id) {
      try {
        const result = await getGroupDetails(
          paramsClientProject,
          extractSavedSearchId(id)
        );
        setSavedGroupDetails(result?.data?.data);
      } catch (error: unknown) {
        const err = error as AxiosError;
        showToast(err.message, 'error', undefined, 'center');
      }
    }
  };

  /**
   * Get details of selected saved search item
   */
  const fetchSavedSearchDetails = async (id: string, docCount = true) => {
    if (docCount) {
      setLoadingFlyout(true);
    }
    if (clientId && projectId) {
      try {
        const params = `?clientId=${clientId}&projectId=${projectId}`;
        const result = await getSavedSearchDetails(
          params,
          extractSavedSearchId(id)
        );
        const { data } = result.data;
        data.query = data.query && unwrapQueryText(data.query);
        if (handleSearchId) {
          dispatch(setSavedSearchLastRun(!checkSavedSearchLastRun(data)));
        }
        setSavedSearchedDetails(data);
        setLoadingLastDocCount(false);
      } catch (error: unknown) {
        const err = error as AxiosError;
        showToast(err.message, 'error', undefined, 'center');
        setLoadingLastDocCount(false);
        handleClose();
      } finally {
        setLoadingFlyout(false);
      }
    }
  };

  const handleSavedSearchRun = async () => {
    setLoadingLastDocCount(true);
    const title = savedSearchedDetails.fieldTemplateId?.toString();
    const ecaSearchId = savedSearchedDetails.ecaSearchId;
    const params = `?clientId=${clientId}&projectId=${projectId}`;
    try {
      if (clientId && projectId && ecaSearchId) {
        const url =
          `/indexes/${title}/savedSearches/${ecaSearchId}/run` + params;
        if (abortControllers.current.has(url)) {
          abortControllers.current.get(url)?.abort();
        }
        if (eventSourceRef.current) {
          eventSourceRef.current.close();
          eventSourceRef.current = null;
        }
        const controller = new AbortController();
        abortControllers.current.set(url, controller);
        const result = await savedSearchedRun(
          params,
          title,
          ecaSearchId,
          controller.signal
        );
        getSearchIdSse(result.data?.data?.requestId);
        abortControllers.current.delete(url);
      }
    } catch (error: any) {
      setLoadingLastDocCount(false);
      if (error.name === 'CanceledError') {
        return;
      }
      abortControllers.current.delete(
        `/indexes/${title}/savedSearches/${ecaSearchId}/run` + params
      );
    }
  };

  useEffect(() => {
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
      abortControllers.current.forEach((controller) => {
        controller.abort();
      });
      abortControllers.current.clear();
    };
  }, [savedSearchedDetails.ecaSearchId]);

  const eventSourceRef = useRef<EventSource | null>(null);
  const getSearchIdSse = useCallback(
    (requestId: string) => {
      if (requestId && requestId != '') {
        const SSE_URL = `${SSE_ENDPOINT_ECA}/sse/${requestId}/${SSE_SERVICE_TYPE.SEARCH_SERVICE}`;
        eventSourceRef.current = new EventSource(SSE_URL);
        eventSourceRef.current.onmessage = (event) => {
          eventSourceRef.current?.close();
          const responseData = JSON.parse(event.data);
          if (responseData.status.toLowerCase() == 'completed') {
            fetchSavedSearchDetails(savedSearchedDetails.id, false);
          } else {
            showToast(t('common.somethingWrong'), 'error', undefined, 'center');
            setLoadingLastDocCount(false);
          }
          eventSourceRef.current?.close();
        };

        eventSourceRef.current.onerror = () => {
          setLoadingLastDocCount(false);
          showToast(t('common.somethingWrong'), 'error', undefined, 'center');
          eventSourceRef.current?.close(); // Close previous connection if it exists
        };
      }
    },
    [savedSearchedDetails.ecaSearchId]
  );

  const handleNameEditClick = (name: string) => {
    setRenameSearchError(false);
    setRenameSearch(name);
    setIsNameEditing(true);
  };

  const renameSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setRenameSearchError(!isValidName(value));
    setRenameSearch(value);
  };

  useEffect(() => {
    if (isDeleteSuccessful) {
      handleClose();
      setLoading(true);
      setSaveSearchedData([]);
      fetchSaveSearchGroupsRoot(
        searchKeyword
          ? { searchTerm: searchKeyword, indexName: selectedIndex }
          : {},
        false,
        true
      );
    }
  }, [isDeleteSuccessful]);

  const handleSaveNameClick = async () => {
    setIsSaving(true);
    const syntaxQuery = wrapQueryBeforeSymbol(
      savedSearchedDetails?.query +
      createQueryUsingScopeObj(savedSearchedDetails?.scope)
    );
    const reqBody: SavedSearchDetails = {
      ...savedSearchedDetails,
      name: renameSearch,
      query: syntaxQuery,
      noScopeDtSyntaxQuery: wrapQueryBeforeSymbol(savedSearchedDetails?.query),
      dtSyntaxQuery: syntaxQuery,
      relationalGroupFieldList: savedSearchedDetails?.relationalGroups,
      relationalGroups: undefined,
    };
    if (queryData.queryBuilderMode) {
      reqBody.jsonLogicQuery = JSON.stringify(builder);
    }
    try {
      const results = await updateSaveSearchDetails(
        paramsClientProject,
        savedSearchedDetails.id,
        reqBody
      );
      if (results) {
        handleClose();
        setLoading(true);
        setSaveSearchedData([]);
        fetchSaveSearchGroupsRoot({}, false, true);
      }
    } catch (error: unknown) {
      const e = error as AxiosError;
      showToast(e.message, 'error', undefined, 'center');
    } finally {
      setIsSaving(false);
    }
  };

  const handleSaveNotes = async (id: string) => {
    setIsLoadingEditNotes(true);
    const formattedUpdatedNotes = updatedNotes
      .split('\n')
      .filter((i) => i)
      .join('\n');
    const syntaxQuery = wrapQueryBeforeSymbol(
      savedSearchedDetails?.query +
      createQueryUsingScopeObj(savedSearchedDetails?.scope)
    );
    const reqBody: SavedSearchDetails = {
      ...savedSearchedDetails,
      notes: formattedUpdatedNotes,
      query: syntaxQuery,
      noScopeDtSyntaxQuery: wrapQueryBeforeSymbol(savedSearchedDetails?.query),
      dtSyntaxQuery: syntaxQuery,
      relationalGroupFieldList: savedSearchedDetails?.relationalGroups,
      relationalGroups: undefined,
    };
    if (queryData.queryBuilderMode) {
      reqBody.jsonLogicQuery = JSON.stringify(builder);
    }
    try {
      const results = await updateSaveSearchDetails(
        paramsClientProject,
        id,
        reqBody
      );
      if (results) {
        setIsEditNotes(false);
        fetchSavedSearchDetails(savedSearchedDetails.id);
        setIsLoadingEditNotes(false);
      }
    } catch (error: unknown) {
      const e = error as AxiosError;
      showToast(e.message, 'error', undefined, 'center');
      setIsLoadingEditNotes(false);
    }
  };

  /**
   * Render flyout
   * @returns
   */
  const InitialContent = useCallback(() => {
    return (
      <Box className="flyout-container-saved-search">
        <Typography
          className="typo-text subhead3_size folder-title"
          tabIndex={0}
        >
          {t('eca.flyout.savedSearch.summary')}
        </Typography>
      </Box>
    );
  }, []);

  const renderDateFieldWithTooltip = (value: string) => {
    return (
      <AurLightTooltip title={t('common.yearMonthDate')}>
        <Typography
          className="typo-text body4_size location-label"
          tabIndex={0}
        >
          {getUTCDateTimeForDisplay(value)}
        </Typography>
      </AurLightTooltip>
    );
  };

  const renderCellDateTimeWithTooltip = (value?: string) => {
    return (
      <AurLightTooltip title={t('common.yearMonthDate')}>
        <Typography
          className="typo-text body4_size custom-color-cell"
          tabIndex={0}
        >
          {value && getUTCDateTimeForDisplay(value)}
        </Typography>
      </AurLightTooltip>
    );
  };

  const renderFolderContent = (
    id: string,
    name: string,
    savedGroupDetail: ISavedGroupDetails
  ) => {
    const { createdBy, createdTime, updatedBy, updatedTime } = savedGroupDetail;

    return (
      <Box className="flyout-container-saved-search">
        <Typography
          className="typo-text subhead3_size folder-title"
          tabIndex={0}
        >
          {name || ''}
        </Typography>
        <Box className="copy-id">
          <Typography
            className="typo-text body4_size location-label"
            tabIndex={0}
          >
            {t('eca.flyout.id')}:
          </Typography>
          <Typography
            className="typo-text body4_size location-label"
            tabIndex={0}
          >
            {extractSavedSearchId(id)}
          </Typography>
        </Box>
        <Box className="details-container">
          <Box className="copy-id folder-details-row">
            <Typography className="typo-text label2_size label-id" tabIndex={0}>
              {t('eca.flyout.savedSearch.createdOn')}
            </Typography>
            {renderDateFieldWithTooltip(createdTime)}
          </Box>
          <Box className="copy-id folder-details-row">
            <Typography className="typo-text label2_size label-id" tabIndex={0}>
              {t('eca.flyout.savedSearch.createdBy')}
            </Typography>
            <Typography
              className="typo-text body4_size location-label"
              tabIndex={0}
            >
              {createdBy != '' ? createdBy : '--'}
            </Typography>
          </Box>
          <Box className="copy-id folder-details-row">
            <Typography className="typo-text label2_size label-id" tabIndex={0}>
              {t('eca.flyout.savedSearch.modifiedOn')}
            </Typography>
            {renderDateFieldWithTooltip(updatedTime)}
          </Box>
          <Box className="copy-id folder-details-row">
            <Typography className="typo-text label2_size label-id" tabIndex={0}>
              {t('eca.flyout.savedSearch.modifiedBy')}
            </Typography>
            <Typography
              className="typo-text body4_size location-label"
              tabIndex={0}
            >
              {updatedBy != '' ? updatedBy : '--'}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };
  const renderLoadFlyoutContent = () => {
    const {
      id = '',
      name = '',
      docCount = 0,
      lastRunDetail: {lastRunUserName = '', lastRunTime = ''} = {
        lastRunUserName: '',
        lastRunTime: '',
        lastRunUserId: '',
      },
      createdDetail: {
        createdUserName = '',
        createdTime = '',
        createdUserId = '',
      } = {
        createdUserName: '',
        createdTime: '',
        createdUserId: '',
      },
      updatedDetail: { updatedUserName = '', updatedTime = '' } = {
        updatedUserName: '',
        updatedTime: '',
      },
      query = '',
      applyFilter = false,
      filterSet,
      columnOrder = [''],
      sortOrder = [
        {
          column: '',
          direction: '',
        },
      ],
      notes = '',
      indexName: indexNameValue,
      isDefault = false,
      ecaSearchId,
    } = savedSearchedDetails;

    let documentCount = docCount;
    if (applyFilter && filterSet?.items?.length) {
      documentCount = savedSearchedDetails.filteredDocCount ?? docCount;
    }

    const handleDelete = () => {
      dispatch(setSavedSearchDeleteConfirm(true));
      dispatch(setIsDeduplicationModal(true));
    };

    const handleEditNotes = () => {
      setIsEditNotes(true);
      setUpdatedNotes(notes);
    };

    const hasValidLastRun = checkSavedSearchLastRun(savedSearchedDetails);

    const canDelete = ecaAdminPermission ? true : createdUserId === userId;

    return (
      <div id="eca-flyout-container">
        <Box className="flyout-container-saved-search">
          {loadingFlyout ? (
            <AurLoadingIndicator
              show={true}
              size={48}
              className="loader-save-search"
            />
          ) : (
            <>
              <Box
                className="flyout-header"
                component="aside"
                aria-labelledby="saved-search-title"
              >
                {!openForPickSavedSearch && (
                  <Box className="header-close-copy">
                    {!manageSaved && (
                      <AurButton
                        classNames={'close-button'}
                        label={t('buttons.close')}
                        ariaLabel={t('buttons.close')}
                        type="exit"
                        size="Small"
                        title={t('buttons.close')}
                        dataTestId="close-btn"
                        onClick={handleClose}
                      />
                    )}
                    <Box className="copy-id">
                      <Typography
                        className="typo-text label2_size label-id"
                        tabIndex={0}
                      >
                        {t('eca.flyout.id')}:
                      </Typography>
                      <Typography
                        className="typo-text label2_size value-id"
                        tabIndex={0}
                      >
                        {ecaSearchId}
                      </Typography>
                      <AurIconButton
                        onClick={() => {
                          navigator.clipboard.writeText(ecaSearchId);
                        }}
                        className="copy-id-pointer"
                        ariaLabel={t('eca.flyout.savedSearch.copyID')}
                        size="small"
                        icon={
                          <AurIcon
                            icon={IconNames.ContentCopyOutlined}
                            color={IconColors.Custom}
                            size="small"
                            customClassName="copy-id-icon"
                          />
                        }
                      />
                    </Box>
                  </Box>
                )}
                <Box className="name-container">
                  {!isNameEditing ? (
                    <Typography
                      tabIndex={0}
                      id="saved-search-title"
                      className={`typo-text ${openForPickSavedSearch ? 'subhead3_size custom-color' : 'headline2_size'} custom-title-text`}
                    >
                      {name}
                    </Typography>
                  ) : (
                    <AurTextField
                      error={renameSearchError}
                      helperText={
                        renameSearchError
                          ? t('eca.flyout.savedSearch.nameError')
                          : ''
                      }
                      data-testid="rename-save-search"
                      name={t('eca.flyout.savedSearch.name')}
                      onChange={renameSearchHandler}
                      value={renameSearch}
                      fullWidth
                      label={t('eca.flyout.savedSearch.name')}
                      variant="filled"
                      className={`aur-textfield rename-text-field`}
                      ariaLabel={t('eca.flyout.savedSearch.name')}
                      inputProps={{
                        maxLength: 50,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {renameSearchError ? (
                              <InfoIcon />
                            ) : (
                              <>
                                <AurButton
                                  classNames="cancel-button"
                                  onClick={() => setIsNameEditing(false)}
                                  type="exit"
                                  size="Small"
                                  dataTestId="cancel-button"
                                  label={t('eca.flyout.savedSearch.cancel')}
                                  minWidth={54}
                                />
                                <AurLoadingButton
                                  classNames="save-button"
                                  onClick={handleSaveNameClick}
                                  size="Small"
                                  dataTestId="rename-name-button"
                                  label={t('eca.flyout.savedSearch.save')}
                                  minWidth={54}
                                  loading={isSaving}
                                  disabled={isSaving}
                                />
                              </>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  {!openForPickSavedSearch &&
                    !manageSaved &&
                    !isNameEditing &&
                    !isDefault && (
                      <AurIconButton
                        size="small"
                        onClick={() => handleNameEditClick(name)}
                        shape
                        icon={<AurIcon icon={IconNames.Edit} />}
                        dataTestId="edit-name-button"
                        ariaLabel={t('eca.flyout.savedSearch.editSearchName')}
                      />
                    )}
                </Box>
                {openForPickSavedSearch && !manageSaved && (
                  <Box marginBottom={2} display="flex" gap={0.25}>
                    <Typography
                      className="typo-text label2_size label-id-v2"
                      tabIndex={0}
                    >
                      {t('eca.flyout.id')}:
                    </Typography>
                    <Typography
                      className={`typo-text label2_size label-id-v2`}
                      tabIndex={0}
                    >
                      {ecaSearchId}
                    </Typography>
                  </Box>
                )}
                <Box
                  className={`last-doc-count ${openForPickSavedSearch ? 'open-for-pick-search' : ''}`}
                >
                  <Typography
                    className="typo-text subhead4_size last-doc-count-content"
                    tabIndex={0}
                  >
                    <span className="typo-text subhead4_size">
                      {t('eca.flyout.lastDocCount')}
                    </span>
                    <span className="typo-text body2_size">
                      {!isNaN(documentCount) && hasValidLastRun
                        ? formatNumberWithComma(documentCount)
                        : '--'}
                    </span>
                  </Typography>

                  <AurButton
                    tabIndex={0}
                    classNames="refresh-box"
                    onClick={() => {
                      selectedNode?.id && handleSavedSearchRun();
                    }}
                    disabled={loadingLastDocCount}
                    onKeyDown={(e) => {
                      if (e.key == 'Enter' || e.key == ' ') {
                        selectedNode?.id && handleSavedSearchRun();
                      }
                    }}
                    dataTestId="refresh-count-icon"
                    type={'text'}
                    ariaLabel={t('eca.flyout.savedSearch.refreshDocCount')}
                    size={'Small'}
                  >
                    {loadingLastDocCount ? (
                      <AurLoadingIndicator
                        show={true}
                        size={16}
                      ></AurLoadingIndicator>
                    ) : (
                      <AurIcon
                        icon={IconNames.CachedIcon}
                        color={IconColors.Custom}
                        customClassName="refresh-icon"
                      />
                    )}{' '}
                    <Typography
                      className="typo-text buttonSmall_size refresh-content"
                      tabIndex={0}
                    >
                      {t('eca.flyout.savedSearch.refreshDocCount')}
                    </Typography>
                  </AurButton>

                  {!hasValidLastRun && handleSearchId && (
                    <AurBanner
                      errorText={t('indexes.customIndex.lastRunBanner')}
                      showIcon={true}
                      errorType="warning"
                      textContainerCustomClass="textContainerCustomClass"
                    />
                  )}
                </Box>
              </Box>

              <Box className="cell-container" component="section" aria-labelledby="saved-search-metadata">
                <Box className="row-style">
                  <Box className="label-text">
                    <Typography
                      className="typo-text body4_size custom-color-cell"
                      tabIndex={0}
                      id="saved-search-metadata"
                    >
                      {t('eca.flyout.savedSearch.lastRun')}:
                    </Typography>
                  </Box>
                  {hasValidLastRun ? (
                    <Box
                      className={`value-text ${openForPickSavedSearch && 'value-text-column'}`}
                    >
                      <Typography
                        className="typo-text body4_size custom-color-cell user-name-value"
                        tabIndex={0}
                      >
                        {lastRunUserName}
                      </Typography>

                      <Box
                        className={`time-stamp-value ${openForPickSavedSearch && 'time-stamp-value-v2'}`}
                      >
                        {renderCellDateTimeWithTooltip(lastRunTime)}
                      </Box>
                    </Box>
                  ) : null}
                </Box>
                <Divider orientation="horizontal" flexItem />
                <Box className="row-style">
                  <Box className="label-text">
                    <Typography
                      className="typo-text body4_size custom-color-cell"
                      tabIndex={0}
                    >
                      {t('eca.flyout.savedSearch.created')}:
                    </Typography>
                  </Box>
                  <Box
                    className={`value-text ${openForPickSavedSearch && 'value-text-column'}`}
                  >
                    <Typography
                      className="typo-text body4_size custom-color-cell user-name-value"
                      tabIndex={0}
                    >
                      {createdUserName}
                    </Typography>

                    <Box
                      className={`time-stamp-value ${openForPickSavedSearch && 'time-stamp-value-v2'}`}
                    >
                      {renderCellDateTimeWithTooltip(createdTime)}
                    </Box>
                  </Box>
                </Box>
                <Divider orientation="horizontal" flexItem />
                <Box className="row-style">
                  <Box className="label-text">
                    <Typography
                      className="typo-text body4_size custom-color-cell"
                      tabIndex={0}
                    >
                      {t('eca.flyout.savedSearch.modified')}:
                    </Typography>
                  </Box>
                  <Box
                    className={`value-text ${openForPickSavedSearch && 'value-text-column'}`}
                  >
                    <Typography
                      className="typo-text body4_size custom-color-cell user-name-value"
                      tabIndex={0}
                    >
                      {updatedUserName}
                    </Typography>

                    <Box
                      className={`time-stamp-value ${openForPickSavedSearch && 'time-stamp-value-v2'}`}
                    >
                      {renderCellDateTimeWithTooltip(updatedTime)}
                    </Box>
                  </Box>
                </Box>
              </Box>

              {!openForPickSavedSearch && !manageSaved && (
                <Box>
                  <Box className="flyout-doc-button-container" component="section" aria-labelledby="saved-search-actions">
                    <Box className="flyout-doc-text">
                      <Typography
                        className="typo-text body3_size custom-color"
                        tabIndex={0}
                        id="saved-search-actions"
                      >
                        {t('eca.flyout.savedSearch.viewDocTitle1')}{' '}
                        <span className="typo-text label1_size ">
                          {t('eca.flyout.savedSearch.viewDocTitle2')}
                        </span>
                        {t('eca.flyout.savedSearch.viewDocTitle3')}
                      </Typography>
                      <Typography
                        className="typo-text label4_size custom-color-orange view-doc-warning"
                        tabIndex={0}
                      >
                        {t('eca.flyout.viewDocSubTitle')}
                      </Typography>
                    </Box>
                    <AurButton
                      classNames="doc-button"
                      type="continue"
                      size="Small"
                      dataTestId="view-doc-button"
                      label={t('eca.flyout.viewDocBtn')}
                      minWidth={flyoutButtonMinWidth}
                      onClick={() => {
                        if (selectedNode) {
                          if (hasDisabledRGFs) {
                            dispatch(setIsDeduplicationModal(true));
                            setShowRGFWarningPopup(true);
                            setSelectedAction(LOAD_DOC_TYPE.SAVED_DOC);
                          } else {
                            onViewDocClick();
                          }
                        }
                      }}
                    />
                  </Box>

                  <Divider orientation="horizontal" flexItem />
                  <Box
                    className="flyout-doc-button-container"
                    component="section"
                    aria-labelledby="saved-search-text-action"
                  >
                    <Box className="flyout-doc-text">
                      <Typography
                        className="typo-text body3_size custom-color"
                        tabIndex={0}
                        id="saved-search-text-action"
                      >
                        {savedSearchedDetails?.scope?.scopeType ===
                          SCOPE_TYPE.SAVED_SEARCH
                          ? t('eca.flyout.savedSearch.scopeDisableTitle')
                          : t('eca.flyout.savedSearch.scopeTitle')}
                      </Typography>
                    </Box>
                    <AurButton
                      classNames="doc-button disabled-button"
                      type="continue"
                      size="Small"
                      dataTestId="scope-button"
                      label={t('eca.flyout.scopeBtn')}
                      minWidth={flyoutButtonMinWidth}
                      disabled={
                        savedSearchedDetails?.scope?.scopeType ===
                        SCOPE_TYPE.SAVED_SEARCH
                      }
                      onClick={() => {
                        if (selectedNode) {
                          if (hasDisabledRGFs) {
                            dispatch(setIsDeduplicationModal(true));
                            setShowRGFWarningPopup(true);
                            setSelectedAction(
                              LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE
                            );
                          } else {
                            onUseScopeClick();
                          }
                        }
                      }}
                    />
                  </Box>

                  {!isDefault && (
                    <>
                      <Divider orientation="horizontal" flexItem />
                      <Box
                        className="flyout-doc-button-container"
                        component="section"
                        aria-labelledby="saved-search-doc-subtitle"
                      >
                        <Box className="flyout-doc-text">
                          <Typography
                            className="typo-text body3_size custom-color"
                            tabIndex={0}
                            id="saved-search-doc-subtitle"
                          >
                            {t('eca.flyout.savedSearch.editDocTitle')}
                          </Typography>
                          <Typography
                            className="typo-text label4_size custom-color-orange view-doc-warning"
                            tabIndex={0}
                          >
                            {t('eca.flyout.editDocSubTitle')}
                          </Typography>
                        </Box>
                        <AurButton
                          classNames="doc-button"
                          type="continue"
                          size="Small"
                          dataTestId="edit-doc-button"
                          label={t('buttons.edit')}
                          minWidth={flyoutButtonMinWidth}
                          onClick={() => {
                            if (selectedNode) {
                              if (hasDisabledRGFs) {
                                dispatch(setIsDeduplicationModal(true));
                                setShowRGFWarningPopup(true);
                                setSelectedAction(
                                  LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT
                                );
                              } else {
                                onEditSaveSearch();
                              }
                            }
                          }}
                        />
                      </Box>
                    </>
                  )}
                  {hasSavedSearchTemplatesPerm && (
                    <>
                      {/* logic needs to be updated */}
                      <Divider orientation="horizontal" flexItem />
                      <Box
                        className="flyout-doc-button-container"
                        component="section"
                        aria-labelledby="saved-search-title-sub"
                      >
                        <Box className="flyout-doc-text">
                          <Typography
                            className="typo-text body3_size custom-color"
                            tabIndex={0}
                            id="saved-search-title-sub"
                          >
                            {t('eca.flyout.savedSearch.savedSearchTitle')}
                          </Typography>
                          <Typography
                            className="typo-text label4_size custom-color-orange view-doc-warning"
                            tabIndex={0}
                          >
                            {t('eca.flyout.savedSearch.savedSearchSubTitle')}
                          </Typography>
                        </Box>
                        <AurButton
                          classNames="doc-button"
                          type="continue"
                          size="Small"
                          dataTestId="view-saved-doc-button"
                          label={t('buttons.addToTemplate')}
                          minWidth={flyoutButtonMinWidth}
                          onClick={() => {
                            if (selectedNode) {
                              handleAddToTemplate?.(selectedNode);
                              handleAddToTemplateClose();
                            }
                          }}
                        />
                      </Box>
                    </>
                  )}
                </Box>
              )}

              <Box className="parameters-section" component="section" aria-labelledby="saved-search-parameter-section">
                <Box className="parameters-heading">
                  <Typography
                    className="typo-text subhead4_size custom-color"
                    tabIndex={0}
                    id="saved-search-parameter-section"
                  >
                    {t('eca.flyout.savedSearch.parameters')}
                  </Typography>
                  <AurTooltip
                    describeChild
                    title={t('eca.flyout.savedSearch.tooltip.copyButton')}
                    className="tooltip-content typo-text label3_size"
                    arrowPosition="right"
                    disableInteractive
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [-35, 0],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <div>
                      <AurIconButton
                        icon={
                          <AurIcon
                            icon={IconNames.ContentCopyOutlined}
                            color={IconColors.Primary}
                            size="medium"
                          />
                        }
                        onClick={() => {
                          navigator.clipboard.writeText(query);
                        }}
                        ariaLabel={t('eca.flyout.savedSearch.copyParameters')}
                      />
                    </div>
                  </AurTooltip>
                </Box>

                <Box className="parameters-item">
                  <Box className="content-single-row">
                    <Typography className="typo-text label2_size" tabIndex={0}>
                      {indexNameLabel}:
                    </Typography>
                    <Typography
                      className="typo-text body3_size parameter-value"
                      tabIndex={0}
                    >
                      {indexNameValue}
                    </Typography>
                  </Box>
                </Box>

                <Divider orientation="horizontal" flexItem />
                <Box className="parameters-item">
                  <Box className="content-single-row">
                    <Typography className="typo-text label2_size" tabIndex={0}>
                      {t('eca.flyout.savedSearch.scope')}:
                    </Typography>
                    <Typography
                      className="typo-text body3_size parameter-value"
                      tabIndex={0}
                    >
                      {savedSearchedDetails?.scope?.scopeName
                        ? getLabelFromScopeQuery(
                          savedSearchedDetails?.scope?.scopeName
                        )
                        : t('common.none')}
                    </Typography>
                  </Box>
                </Box>
                <Divider orientation="horizontal" flexItem />
                <Box className="parameters-item">
                  <Box
                    className={`${savedSearchedDetails.relationalGroupList?.length ? 'relational-grp-details' : 'content-single-row'}`}
                  >
                    <Typography className="typo-text label2_size" tabIndex={0}>
                      {t('eca.flyout.savedSearch.relationalGroup')}:
                    </Typography>
                    <Typography
                      className="typo-text body3_size parameter-value relational-grp-labels"
                      tabIndex={0}
                    >
                      {savedSearchedDetails.relationalGroupList?.length ? (
                        <>
                          {savedSearchedDetails.relationalGroupList?.map(
                            (i) => (
                              <Typography
                                tabIndex={0}
                                className="typo-text body3_size custom-color-cell"
                                key={i.id}
                              >
                                {i.name}
                              </Typography>
                            )
                          )}
                        </>
                      ) : (
                        t('common.none')
                      )}
                    </Typography>
                  </Box>
                </Box>
                <Divider orientation="horizontal" flexItem />
                <Box className="accordian-item">
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<GridExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      aria-label={`${t('eca.flyout.savedSearch.searchQuery')} ${t('eca.flyout.savedSearch.syntax')}`}
                    >
                      <Typography
                        tabIndex={0}
                        component="span"
                        className="typo-text label2_size"
                      >
                        {t('eca.flyout.savedSearch.syntax')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        tabIndex={0}
                        className="typo-text body3_size parameter-value"
                      >
                        {query}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Box>
                <Divider orientation="horizontal" flexItem />
                <Box className="accordian-item">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<GridExpandMoreIcon />}
                      aria-controls="panel3-content"
                      id="panel3-header"
                    >
                      <Typography
                        component="span"
                        className="typo-text label2_size"
                      >
                        {t('eca.flyout.savedSearch.columnsSortOrder')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className="typo-text label2_size">
                        {t('eca.flyout.savedSearch.columns')}:
                      </Typography>
                      {columnOrder.map((i) => (
                        <Typography
                          key={i}
                          className="typo-text body3_size parameter-value"
                        >
                          {i}
                        </Typography>
                      ))}
                      <p className="typo-text label2_size"></p>
                      <Typography className="typo-text label2_size">
                        {t('eca.flyout.savedSearch.sortOrder')}:
                      </Typography>
                      {sortOrder.map((i) => (
                        <Typography
                          key={i.column}
                          className="typo-text body3_size parameter-value"
                        >
                          <span>{i.column}: </span>
                          <span>{i.direction.toUpperCase()}</span>
                        </Typography>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Box>

              {showNotes && (!isDefault || (isDefault && notes)) ? (
                <>
                  {isEditNotes ? (
                    <Box
                      className="edit-note-content"
                      component="section"
                      aria-labelledby="saved-search-edit-note"
                    >
                      <Typography
                        className="typo-text subhead4_size custom-color"
                        id="saved-search-edit-note"
                      >
                        {t('eca.flyout.savedSearch.notes')}
                      </Typography>
                      <AurTextField
                        variant="filled"
                        maxRows={5}
                        fullWidth
                        multiline
                        className="aur-textfield custom-text-field"
                        inputProps={{
                          maxLength: MAX_CHAR,
                        }}
                        value={updatedNotes}
                        onChange={(e) => {
                          setUpdatedNotes(e.target.value);
                        }}
                        ariaLabel={t('eca.flyout.savedSearch.notes')}
                        sx={{
                          '& .MuiInputBase-root': {
                            resize: 'vertical',
                            overflow: 'auto',
                            display: 'flex',
                            alignItems: 'flex-start',
                          },
                        }}
                        data-testid="edit-notes-input"
                        helperText={t('eca.flyout.savedSearch.noteHelpText')}
                      />
                      <Box className="edit-note-btn-container">
                        <AurButton
                          classNames="custom-btn"
                          type="exit"
                          label={t('buttons.cancel')}
                          size="Small"
                          title={t('buttons.cancel')}
                          onClick={() => {
                            setIsEditNotes(false);
                            setUpdatedNotes('');
                          }}
                          disabled={isLoadingEditNotes}
                        />
                        <AurButton
                          classNames="custom-btn"
                          label={t('buttons.saveChanges')}
                          type="continue"
                          size="Small"
                          dataTestId="edit-note-save"
                          title={t('buttons.saveChanges')}
                          onClick={() => {
                            handleSaveNotes(id);
                          }}
                          disabled={isLoadingEditNotes}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      className="note-section"
                      component="section"
                      aria-labelledby="saved-search-note"
                    >
                      <Box className="note-content">
                        <Typography
                          className="typo-text subhead4_size custom-color"
                          tabIndex={0}
                          id="saved-search-note"
                        >
                          {t('eca.flyout.savedSearch.notes')}
                        </Typography>
                        <Box>
                          {notes.split('\n').map((i: string, index: number) => (
                            <Typography
                              tabIndex={0}
                              key={index + i}
                              className="typo-text body3_size parameter-value"
                            >
                              {i}
                            </Typography>
                          ))}
                        </Box>
                      </Box>
                      {!openForPickSavedSearch &&
                        !isDefault &&
                        !manageSaved && (
                          <AurIconButton
                            size="small"
                            shape
                            dataTestId="edit-notes-button"
                            icon={<AurIcon icon={IconNames.Edit} />}
                            onClick={handleEditNotes}
                            ariaLabel={t('eca.flyout.savedSearch.editNotes')}
                          />
                        )}
                    </Box>
                  )}
                </>
              ) : null}

              {deleteOption && canDelete && !isDefault ? (
                <>
                  <Divider orientation="horizontal" flexItem />
                  <Box className="delete-section">
                    <Box className="delete-content">
                      <Typography
                        className="typo-text body3_size custom-color"
                        tabIndex={0}
                      >
                        {t('eca.flyout.deleteContent')}
                      </Typography>
                      <AurButton
                        classNames={'delete-button'}
                        label={t('buttons.delete')}
                        type="exit"
                        size="Small"
                        title={t('buttons.delete')}
                        dataTestId="delete-btn"
                        onClick={handleDelete}
                        ariaLabel={t('eca.flyout.savedSearch.deleteSearch')}
                      />
                    </Box>
                  </Box>
                </>
              ) : null}
            </>
          )}
        </Box>
      </div>
    );
  };

  const handleSelectedItem = useCallback(
    (
      selectedNode: TreeViewBaseItem<ExtendedTreeItemProps>,
      event?: React.SyntheticEvent
    ) => {
      onPickTreeItem?.(selectedNode);
      setSelectedNodeToMove(selectedNode || '');

      if (selectedNode.fileType !== 'folder') {
        setSelectedNode(selectedNode);
        onPickSavedSearch?.({
          id: selectedNode.id,
          label: selectedNode.label,
          ecaSearchId: selectedNode.ecaSearchId ?? '',
          directory_structure_ids: selectedNode.directory_structure_ids,
        });
        if (event) {
          fetchSavedSearchDetails(extractSavedSearchId(selectedNode.id));
          if (enableFlayout) {
            setAnchorEl(
              drawerRef?.current ?? (event.currentTarget as HTMLElement)
            );
            setShowFlyout(true);
            setTimeout(() => {
              document.getElementById('eca-flyout-container')?.focus();
            }, 100);
          } else {
            renderSelectedSearchDetail?.(renderLoadFlyoutContent());
          }
        }
      } else if (
        selectedNode.fileType === 'folder' &&
        renderSelectedSearchDetail &&
        folderDetailsView &&
        !addGroupCheckStatus
      ) {
        fetchGroupDetails(selectedNode.id);
        setSelectedGroupName(selectedNode.label);
        setSelectedGroupId(selectedNode.id);
      }
    },
    [
      addGroupCheckStatus,
      drawerRef,
      enableFlayout,
      folderDetailsView,
      onPickSavedSearch,
      onPickTreeItem,
      renderSelectedSearchDetail,
    ]
  );

  /**
   * Handle close flyout
   */
  const handleClose = () => {
    setShowFlyout(false);
    setSelectedNode(null);
    setIsNameEditing(false);
    setIsEditNotes(false);
    setUpdatedNotes('');
    setSavedSearchedDetails(initialSavedSearchDetails);
  };

  const handleAddToTemplateClose = () => {
    setShowFlyout(false);
    setIsNameEditing(false);
    setIsEditNotes(false);
    setUpdatedNotes('');
    setSavedSearchedDetails(initialSavedSearchDetails);
  };

  const handlePopupClose = () => {
    setPopupState({ open: false, type: '', id: '', label: '', path: '' });
  };

  const handlePopupOk = () => {
    if (popupState.type === 'deleteGroup') {
      deleteSavedSearchGroupHandler(
        popupState.id,
        popupState.label,
        popupState.path
      );
    } else if (popupState.type === 'deleteSavedSearch') {
      deleteSavedSearchHandler(
        popupState.id,
        popupState.label,
        popupState.path
      );
    } else {
      handlePopupClose();
    }
  };

  const handleDeleteFromOverflowMenu = (
    node: TreeViewBaseItem<ExtendedTreeItemProps>
  ) => {
    if (node.fileType === 'folder') {
      if (node.children?.length) {
        setPopupState({
          open: true,
          type: 'cantDeleteGroup',
          id: node.id,
          label: node.label,
          path: node?.directory_structure_ids ?? '',
        });
      } else {
        setPopupState({
          open: true,
          type: 'deleteGroup',
          id: node.id,
          label: node.label,
          path: node?.directory_structure_ids ?? '',
        });
      }
    } else {
      setPopupState({
        open: true,
        type: 'deleteSavedSearch',
        id: node.id,
        label: node.label,
        path: node?.directory_structure_ids ?? '',
      });
    }
  };

  const handleSelect = useCallback(
    (item: string, node: TreeViewBaseItem<ExtendedTreeItemProps>) => {
      switch (item) {
        case t('eca.flyout.savedSearch.move'):
          setIsMoveModalOpen(true);
          break;
        case t('buttons.delete'):
          handleDeleteFromOverflowMenu(node);
          break;
      }
    },
    []
  );
  const handleCloseMoveModal = () => {
    setIsMoveModalOpen(false);
  };

  const onSuccessAction = (label: string, ignoreExpandedIds = false) => {
    showToast(label, 'success', TOAST_TIMEOUT, 'center', 'bottom');
    setLoading(true);
    setSaveSearchedData([]);
    fetchSaveSearchGroupsRoot(
      searchKeyword
        ? { searchTerm: searchKeyword, indexName: selectedIndex }
        : {},
      ignoreExpandedIds,
      true
    );
  };

  const onActionFailed = (message: string) => {
    showToast(message, 'error', TOAST_TIMEOUT, 'center', 'bottom');
  };
  const deleteSavedSearchGroupHandler = async (
    id: string,
    label: string,
    path: string
  ) => {
    const params = `?clientId=${clientId}&projectId=${projectId}`;
    try {
      const results = await deleteSavedSearchGroup(
        params,
        extractSavedSearchId(id)
      );
      if (results.status === 200) {
        const updatePathCompArray = path.split('/');
        updatePathCompArray.length > 1 && updatePathCompArray.pop();

        const parentID =
          updatePathCompArray.length > 1
            ? updatePathCompArray.at(-1)
            : (updatePathCompArray?.[0] ?? '');
        setSelectedNode(
          !isEmpty(parentID)
            ? ({ id: parentID } as TreeViewBaseItem<ExtendedTreeItemProps>)
            : null
        );

        deleteSuccessAction(label, updatePathCompArray.join('/'));
        renderSelectedSearchDetail?.(InitialContent());
      }
    } catch (e) {
      handlePopupClose();
      onActionFailed(t('eca.savedSearchManagement.searchGroupDeletedError'));
    }
  };

  const deleteSavedSearchHandler = async (
    id: string,
    label: string,
    path: string
  ) => {
    const params = `?clientId=${clientId}&projectId=${projectId}`;
    try {
      const results = await deleteSavedSearch(params, extractSavedSearchId(id));
      if (results.status === 200) {
        const updatePathCompArray = path.split('/');
        const parentID =
          updatePathCompArray.length > 1
            ? updatePathCompArray.at(-1)
            : (updatePathCompArray?.[0] ?? '');

        setSelectedNode(
          !isEmpty(parentID)
            ? ({ id: parentID } as TreeViewBaseItem<ExtendedTreeItemProps>)
            : null
        );

        deleteSuccessAction(label, updatePathCompArray.join('/'));
        renderSelectedSearchDetail?.(InitialContent());
      }
    } catch (error: unknown) {
      const err = error as AxiosError;
      if (err?.status === ERROR_STATUS_CODE.STATUS_409) {
        setPopupState({
          open: true,
          type: 'cantDeleteSavedSearch',
          id: '',
          label: '',
          path: '',
        });
      } else {
        handlePopupClose();
        onActionFailed(t('eca.savedSearchManagement.savedSearchDeletedError'));
      }
    }
  };

  const deleteSuccessAction = (label: string, path: string) => {
    handlePopupClose();
    syncExpandedIds(path.split('/'));
    onSuccessAction(
      t('eca.savedSearchManagement.groupOrSavedSearchDeleted', {
        deletedGroupOrSavedSearchName: label,
      }),
      true
    );
  };

  const renderSearchBox = () => {
    return (
      <Box className="search-container" data-testid="search-container">
        <AurSearchBox
          label={t('common.filterList')}
          minCharForSearch={MIN_SEARCH_CHAR}
          onSearch={(keyword: string) => {
            setSearchKeyword(keyword.trim());
          }}
          classNameProps="filter-text-field"
        />
      </Box>
    );
  };

  const syncExpandedIds = (expandedIds: string[]) => {
    setExpandedNodes(expandedIds);
    setCurrentExpandedIds(expandedIds);
  };

  const onMoveComplete = (
    preExpandedIds: string[],
    selectedNodeToMove: TreeViewBaseItem<ExtendedTreeItemProps>,
    type: string
  ) => {
    syncExpandedIds(preExpandedIds);
    renderSelectedSearchDetail?.(InitialContent());
    isMoveCompleted.current = true;
    if (type === 'SavedSearchGroup') {
      fetchGroupDetails(extractSavedSearchId(selectedNodeToMove.id));
    } else {
      fetchSavedSearchDetails(extractSavedSearchId(selectedNodeToMove.id));
    }
  };

  const getDefaultIds = useCallback(() => {
    const ids = [] as string[];
    const findMatchingIds = (
      node: TreeViewBaseItem<ExtendedTreeItemProps>[]
    ) => {
      node.forEach((item) => {
        if (expandedNodes.includes(item.id)) ids.push(item.id);
        if (item?.children && item.children.length > 0) {
          findMatchingIds(item.children);
        }
      });
    };
    if (treeData) findMatchingIds(treeData);
    return ids?.filter((id) => !!id);
  }, [expandedNodes, JSON.stringify(treeData)]);

  const hasDisabledRGFs = useMemo(() => {
    if (
      relationalGroupsList &&
      savedSearchedDetails.relationalGroupList &&
      isDisabledRGFExistInSavedSearch(
        relationalGroupsList,
        savedSearchedDetails.relationalGroupList
      )
    )
      return true;
    return false;
  }, [savedSearchedDetails.relationalGroupList]);

  const transformedSavedSearchedDetails = useMemo(
    () => ({
      ...savedSearchedDetails,
      query: wrapQueryBeforeSymbol(
        savedSearchedDetails?.query +
          createQueryUsingScopeObj(savedSearchedDetails?.scope)
      ),
      noScopeDtSyntaxQuery: wrapQueryBeforeSymbol(savedSearchedDetails?.query),
      dtSyntaxQuery: wrapQueryBeforeSymbol(
        savedSearchedDetails?.query +
          createQueryUsingScopeObj(savedSearchedDetails?.scope)
      ),
      relationalGroupFieldList: savedSearchedDetails?.relationalGroups,
      relationalGroups: undefined,
    }),
    [savedSearchedDetails]
  );

  const onViewDocClick = () => {
    dispatch(setGlobalSavedSearchDetails(savedSearchedDetails));
    dispatch(setNewSearch(false));
    handleViewDocs?.(LOAD_DOC_TYPE.SAVED_DOC, selectedNode);
    handleClose();
  };

  const onUseScopeClick = () => {
    handleUseAsScope?.(LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE, {
      ...selectedNode,
      ecaSearchId: savedSearchedDetails.ecaSearchId,
    } as never);
    handleClose();
  };

  const onEditSaveSearch = () => {
    dispatch(setGlobalSavedSearchDetails(savedSearchedDetails));
    dispatch(setNewSearch(false));
    handleViewDocs?.(LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT, selectedNode);
    handleClose();
  };

  const handleOnOKQueryRGFWarningAlert = () => {
    setShowRGFWarningPopup(false);
    if (
      selectedAction === LOAD_DOC_TYPE.SAVED_DOC ||
      selectedAction === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT
    ) {
      onEditSaveSearch();
    }
  };

  return (
    <>
      {enableSearch ? renderSearchBox() : null}
      <Box
        className={`drawer-treeview-content custom-treeview ${saveSearchedData.length === 0 && 'zero-saved-search'}`}
        data-testid="location-treeview-content"
      >
        {loading ? (
          <Box className="eca-tab-loader">
            <AurLoadingIndicator show={true} />
          </Box>
        ) : (
          <div className="filtered-saved-search">
            <AurLocationTreeView
              itemsList={saveSearchedData}
              fetchUpdatedRoot={fetchUpdatedSaveSearchGroupsRoot}
              handleSelectedItem={handleSelectedItem}
              selectedItem={selectedNode?.id || ''}
              defaultExpandedIds={currentExpandedIds}
              allowGlobalSelect={true}
              showActions={showActions}
              handleSelect={handleSelect}
              manageSavedSearch={manageSavedSearch}
              manageSearchRename={manageSearchRename}
              savedSearchedDetails={transformedSavedSearchedDetails}
              setExpandedFolders={setExpandedNodes}
              preSelectedId={selectedNode?.id}
              updateTreeData={setTreeData}
              showTooltip={true}
              showTooltipAsNodeName={true}
            />
          </div>
        )}
      </Box>
      <ECAFlyout
        showFlyout={showFlyout}
        anchorEl={anchorEl}
        onClose={handleClose}
        content={renderLoadFlyoutContent()}
        className="custom-popper-saved-search"
      />
      {popupState.open && (
        <AurPopup
          className={`aur-unsaved-changes-popup ${!popupConfig[popupState.type]?.showCancel && 'single-button-popup'}`}
          open={popupState.open}
          onOk={handlePopupOk}
          onCancel={handlePopupClose}
          onClose={handlePopupClose}
          popupTitle={popupConfig[popupState.type]?.title}
          popupHeading={popupConfig[popupState.type]?.heading}
          popupContent={popupConfig[popupState.type]?.content}
          showPopupHeading={true}
          showPopupTitle={true}
          showCloseIcon={true}
          showCancelOption={popupConfig[popupState.type]?.showCancel}
          labelActionCancel={popupConfig[popupState.type]?.buttonCancel}
          labelActionOk={popupConfig[popupState.type]?.buttonYes}
          cancelButtonTitle=""
        />
      )}
      {showSetScopeLoader && (
        <Box className="left-scope-loader">
          <AurLoadingIndicator
            show={showSetScopeLoader}
            className="loader-icon"
          />
        </Box>
      )}
      {isMoveModalOpen && (
        <MoveSavedSearchGroupPopup
          isOpen={isMoveModalOpen}
          onClose={handleCloseMoveModal}
          itemsList={saveSearchedData}
          defaultExpandedIds={getDefaultIds()}
          selectedNodeToMove={selectedNodeToMove}
          savedSearchDetails={transformedSavedSearchedDetails}
          onSuccessAction={onSuccessAction}
          onActionFailed={onActionFailed}
          onMoveComplete={onMoveComplete}
        />
      )}
      {showRGFWarningPopup && (
        <RGFWarningPopupAlert
          disabledRGFLabelArray={
            relationalGroupsList && savedSearchedDetails.relationalGroupList
              ? getDisabledRelationshipFieldText(
                relationalGroupsList,
                savedSearchedDetails?.relationalGroupList
              )
              : ['']
          }
          showDialog={showRGFWarningPopup}
          onOk={handleOnOKQueryRGFWarningAlert}
          onCancel={() => setShowRGFWarningPopup(false)}
        />
      )}
    </>
  );
};

export default SavedSearchPanel;
